module.exports = __webpack_public_path__ + "img/vertical-logo.001c5927.svg";